<section class="sr-other-feedback" [class.sr-other-feedback--overall]="overall" *ngIf="feedbacks.length" [attr.aria-label]="'Outras avaliações: ' + feedbacks.length">
  <span class="sr-other-feedback-label">
    Outras avaliações <span class="sr-other-feedback-count">{{ feedbacks.length }}</span>
  </span>

  <ul class="sr-other-feedback-list">
    <li class="sr-other-feedback-item" *ngFor="let fb of visible; trackBy: trackById">
      <div class="sr-other-feedback-head">
        <po-tag
          class="sr-other-feedback-resolution"
          [attr.data-resolution]="fb.resolution"
          [p-value]="optionOf(fb.resolution)?.label ?? fb.resolution"
          [p-icon]="optionOf(fb.resolution)?.icon">
        </po-tag>
        <po-button
          *ngIf="fb.removable"
          class="sr-other-feedback-remove"
          p-kind="tertiary"
          p-icon="po-icon-delete"
          [p-loading]="removingId === fb.id"
          [p-disabled]="!!removingId"
          [p-aria-label]="'Remover a avaliação de ' + fb.createdBy"
          p-tooltip="Remover avaliação"
          p-tooltip-position="top"
          p-append-in-body="true"
          (p-click)="confirmRemove(fb)">
        </po-button>
      </div>
      <span class="sr-other-feedback-meta">
        <span class="sr-other-feedback-author">{{ fb.createdBy }}</span>
        <span>{{ fb.updatedAt | date: 'dd/MM/yyyy' }}</span>
      </span>
      <p class="sr-other-feedback-comment" *ngIf="fb.comment">{{ fb.comment }}</p>
    </li>
  </ul>

  <po-button
    *ngIf="hiddenCount > 0"
    class="sr-other-feedback-more"
    p-kind="tertiary"
    p-small="true"
    [p-label]="showAll ? 'Mostrar menos' : 'Ver mais (' + hiddenCount + ')'"
    (p-click)="toggleShowAll()">
  </po-button>
</section>

<po-modal
  #removeModal
  p-title="Remover avaliação"
  p-size="sm"
  p-click-out="false"
  p-hide-close="true"
  [p-primary-action]="removePrimaryAction"
  [p-secondary-action]="removeSecondaryAction">
  <p class="sr-other-feedback-remove-text" *ngIf="pendingRemoval">
    Remover a avaliação de <strong>{{ pendingRemoval.createdBy }}</strong>?
    Ela deixa de contar na curadoria.
  </p>
</po-modal>
